"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGetWishlistQueryHandler = void 0;
const query_result_1 = require("./query-result");
class DefaultGetWishlistQueryHandler {
    constructor(wishlistRepository) {
        this.wishlistRepository = wishlistRepository;
    }
    handle({ userId }) {
        return __awaiter(this, void 0, void 0, function* () {
            let wishlist = yield this.wishlistRepository.retrieveByUserId(userId);
            if (wishlist === null) {
                wishlist = yield this.wishlistRepository.createWishlist(userId);
            }
            return new query_result_1.GetWishlistQueryResult(wishlist);
        });
    }
}
exports.DefaultGetWishlistQueryHandler = DefaultGetWishlistQueryHandler;
